import ReviewsPage from '@alumni_v2/pages/reviews';

// const BASE_URL = '/review';

function getStaticRoutes() {
  return {
    '/review': {
      component: ReviewsPage,
      exact: true,
    },
    '/review/embedded': {
      component: ReviewsPage,
      exact: true,
    },
    '/data-science-course/reviews': {
      component: ReviewsPage,
      exact: true,
    },
    '/ai-machine-learning-course/reviews/': {
      component: ReviewsPage,
      exact: true,
    },
  };
}

export function getRoutes() {
  const routes = getStaticRoutes();

  return { routes };
}
